import React from 'react';

export const ContextProvider = React.createContext({});